import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 10px;
  padding: 10px;
  height: 84vh;
  margin-top: 2px;
  padding-top: 25px;
  padding-left: 35px;
  padding-right: 35px;
  padding-bottom: 10px;
  overflow-y: auto;
`;

interface ContainerConteudoProps {
  children: any;
}

function ContainerConteudo(props: ContainerConteudoProps) {
  return <Container>{props.children}</Container>;
}

export default ContainerConteudo;
